var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-wrapper"},[_c('DxDateBox',{attrs:{"value":_vm.now,"height":"50","display-format":"d.MM.yyyy"},on:{"value-changed":_vm.onVlaueChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }